import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutDashboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLayoutDashboard"><Path d="M3 9V3H11V9H3Z" fill="currentColor"/><Path d="M3 11V21L11 21V11H3Z" fill="currentColor"/><Path d="M13 21L21 21V15H13V21Z" fill="currentColor"/><Path d="M21 13V3H13V13H21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutDashboard;
